import React from 'react';
import '../styles/Process.css';

const Process = () => {
  const processSteps = [
    {
      stage: '前置作業',
      details: '(估價服務)',
      steps: [
        {
          id: 1,
          title: '案件諮詢',
          description: '了解需求與預算，設計風格及預算討論'
        },
        {
          id: 2,
          title: '空間丈量',
          description: '勘察及實際丈量空間尺寸'
        },
        {
          id: 3,
          title: '平面規劃',
          description: '平面初步設計，規劃配置'
        },
        {
          id: 4,
          title: '設計簡報&初步報價',
          description: '討論空間簡報及初步工程估價'
        }
      ]
    },
    {
      stage: '設計階段',
      details: '(設計費用)',
      steps: [
        {
          id: 1,
          title: '簽訂設計合約',
          description: '雙方同意設計內容及費用'
        },
        {
          id: 2,
          title: '繪製3D圖',
          description: '精緻3D空間效果圖，讓客戶了解完整設計'
        },
        {
          id: 3,
          title: '設計規劃&設計修改',
          description: '細部空間設計討論，風格、材質、預算等調整'
        },
        {
          id: 4,
          title: '設計定案&工程報價',
          description: '施工項目確認及工程總價估算'
        }
      ]
    },
    {
      stage: '施工階段',
      details: '(工程費用)',
      steps: [
        {
          id: 1,
          title: '簽訂工程合約',
          description: '雙方確認工程內容和費用'
        },
        {
          id: 2,
          title: '進場施作',
          description: '依設計圖面及工程進度進行施工'
        },
        {
          id: 3,
          title: '工程監造',
          description: '現場施工管理及追蹤工程狀況'
        },
        {
          id: 4,
          title: '完工驗收',
          description: '工程完工，業主驗收後交屋'
        }
      ]
    }
  ];

  return (
    <section className="process" id="process">
      <div className="process-container">
        <div className="process-header">
          <h2 className="section-title">服務流程</h2>
        </div>
        <div className="process-flow">
          {processSteps.map((phase, index) => (
            <div className="process-phase" key={index}>
              <div className="phase-header">
                <h3 className="phase-title">{phase.stage}</h3>
                <p className="phase-details">{phase.details}</p>
              </div>
              <div className="phase-steps">
                {phase.steps.map(step => (
                  <div className="step-item" key={step.id}>
                    <div className="step-icon">
                      <span className="step-number">{step.id}</span>
                    </div>
                    <div className="step-content">
                      <h4 className="step-title">{step.title}</h4>
                      <p className="step-description">{step.description}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Process; 